// Delivery state of a mailSent row, as stored by the backend send routes:
// `response.statusCode` is 200 when the provider accepted the message (or the
// row was skipped on purpose), anything else means the mail never went out.
// Legacy rows without a response are treated as sent (TICKET-01841).

export function isMailSentFailed(mailSent) {
    const statusCode = mailSent && mailSent.response ? mailSent.response.statusCode : undefined;
    if (statusCode === undefined || statusCode === null || statusCode === '') {
        return false;
    }
    const code = Number(statusCode);
    if (Number.isNaN(code)) {
        return false;
    }
    return code !== 200;
}

export default { isMailSentFailed };
